'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _validators = require('constructicon/lib/validators');

var _buttonGroup = require('constructicon/button-group');

var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

var _icon = require('constructicon/icon');

var _icon2 = _interopRequireDefault(_icon);

var _section = require('constructicon/section');

var _section2 = _interopRequireDefault(_section);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var containsSubstring = function containsSubstring(valueA, valueB) {
  if (!valueA || !valueB) return false;

  return String(valueA).toLowerCase().indexOf(valueB.toLowerCase()) > -1;
};

var PasswordValidations = function PasswordValidations(_ref) {
  var form = _ref.form;

  var passwordValidations = [{
    label: 'Must be at least 12 characters',
    passes: form.values.password.length > 11
  }, {
    label: 'Must include at least one number, letter and special character (#,$,%,&,@ etc.)',
    passes: _validators.regularExpressions.passwordComplexity.test(form.values.password)
  }, {
    label: 'Must not include your name or email address',
    passes: !containsSubstring(form.values.password, form.values.email) && !containsSubstring(form.values.password, form.values.firstName) && !containsSubstring(form.values.password, form.values.lastName)
  }];

  return _react2.default.createElement(
    _section2.default,
    { spacing: 0, margin: { t: -0.5, b: 0.75 } },
    passwordValidations.map(function (validation, index) {
      return _react2.default.createElement(
        _section2.default,
        {
          foreground: validation.passes && form.fields.password.touched ? 'success' : 'grey',
          key: index,
          spacing: { y: 0.333 },
          textAlign: 'left',
          size: -0.5,
          tag: 'div'
        },
        _react2.default.createElement(
          _buttonGroup2.default,
          { align: 'left', spacing: 0 },
          _react2.default.createElement(_icon2.default, {
            name: validation.passes ? 'check' : 'close',
            color: validation.passes ? 'success' : 'danger'
          }),
          _react2.default.createElement(
            _section2.default,
            {
              spacing: { l: 0.5 },
              styles: { maxWidth: 'calc(100% - 3em)', verticalAlign: 'middle' }
            },
            validation.label
          )
        )
      );
    })
  );
};

exports.default = PasswordValidations;